import axios, { AxiosInstance } from 'axios';
import i18n from '@/i18n';
import mock from 'mock';

const client: AxiosInstance = axios.create({
  baseURL: `${process.env.VUE_APP_API_ENDPOINT}/`,
  timeout: 12000,
  headers: {
    'X-Ekyc-Applicant-Client-Version': process.env.VUE_APP_APPLICANT_CLIENT_VERSION || '',
    'X-Current-Language': i18n.locale // ここは起動時に1回だけ呼ばれるので、i18nでデフォルトとして設定したjaが入る。初期化のタイミングの問題によりブラウザのデフォルト言語ではない
  }
});

export default client;

if (process.env.VUE_APP_API_MODE === 'mock') {
  mock(client);
}
